import { useMemo } from 'react'
import { useIntegrationTypesWithInstances } from '../../utils/api-client/api-hooks.ts'
import { getIsMappableIntegrationType } from '../../utils/repository-utils.tsx'

/**
 * Whether the map-new form has anything to offer.
 *
 * The form's own precondition, shared so the repository settings drawer's "Map new" gate reads the
 * same answer and cannot offer a form that would render its empty state.
 * `/api/v1/integration-types` omits a tool with no instances, so a reported mappable type is one
 * that has one.
 *
 * A failed counts request answers `true`. The failure is not evidence that nothing is mappable, and
 * closing the gate on it would replace it with "No tools have been connected" — a claim about the
 * org that no response ever made. Open, the form renders its tool control, which reads the same
 * query and says the request failed; the user gets one error in the one place that can explain it.
 */
export const useIsMapToolFormOffered = (): boolean => {
  const { types, isError } = useIntegrationTypesWithInstances()
  return useMemo(() => isError || types.some(getIsMappableIntegrationType), [types, isError])
}
